// packages import
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { FC } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
// component import
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { Alert } from "../../common/Alert";
import { CustomController } from "../../common/CustomController";
// others
import { UpdatePasswordInput, useUpdatePasswordMutation } from "../../../../generated";
import { INTERNAL_SERVER_ERROR, USER_PASSWORD_SUCCESS } from "../../../constants";
import { DispatchAndState, UpdatePasswordInputProps } from "../../../interfaceTypes";
import { newPasswordAndRepeatPasswordSchema } from "../../../validationSchema";
import { UserAction, UserState } from "../userReducer";

export const UpdatePassword: FC<DispatchAndState<UserState, UserAction>> = ({ state }) => {
  const { currentUser } = state || {}
  const { id } = currentUser || {}

  const updatePasswordMethods = useForm<UpdatePasswordInputProps>({
    mode: "all",
    resolver: yupResolver(newPasswordAndRepeatPasswordSchema),

    defaultValues: {
      id,
      newPassword: "",
      repeatPassword: ""
    }
  })

  const { handleSubmit: updatePasswordHandleSubmit, reset: updatePasswordReset } = updatePasswordMethods

  const [updatePasswordMutation] = useUpdatePasswordMutation({
    onError() {
      Alert.error(INTERNAL_SERVER_ERROR)
    },

    onCompleted(data) {
      if (data) {
        const { updatePassword: { response } } = data

        if (response) {
          const { status } = response

          if (status === 200) {
            Alert.success(USER_PASSWORD_SUCCESS)
            updatePasswordReset()
          }
        }
      }
    }
  })

  const passwordSubmitHandler: SubmitHandler<UpdatePasswordInput> = async (data: UpdatePasswordInput) => {
    await updatePasswordMutation({
      variables: {
        updatePasswordInput: {
          id: id || "",
          newPassword: data.newPassword
        }
      }
    })
  }

  return (
    <FormProvider {...updatePasswordMethods}>
      <form onSubmit={updatePasswordHandleSubmit(passwordSubmitHandler)}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box flex={1}>
            <Typography variant="h5" fontSize='14px'>Password:</Typography>
          </Box>

          <IconButton type="submit" aria-label="Save">
            <SaveRoundedIcon color='primary' />
          </IconButton>
        </Box>
        
        <Grid container spacing={2} rowSpacing={0.5}>
          <Grid item md={6} sm={12}>
            <CustomController
              controllerName='newPassword'
              controllerLabel='Password'
              fieldType='password'
              isPassword
            />
          </Grid>

          <Grid item md={6} sm={12}>
            <CustomController
              controllerName='repeatPassword'
              controllerLabel='Confirm Password'
              fieldType='password'
              isPassword
            />
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}